import ServiceApi from "../services/service.api";
const baseServiceUrl = `/api/v1/Home`;


const ApiHome = {
  getInfos: () => {
    const url = `${baseServiceUrl}`;
    return ServiceApi.get(url, { params: { a: 1 } });
  },
  getMenu: (params) => {
    const url = `${baseServiceUrl}/getMenu`;
    return ServiceApi.get(url, params);
  },
  getPermision: (params) => {
    const url = `${baseServiceUrl}/getPermision`;
    return ServiceApi.get(url, { params });
  },
  getEnums: (params) => {
    const url = `${baseServiceUrl}/getEnums`;
    return ServiceApi.get(url, { params });
  },
  getPanelDashboard: () => {
    const url = `${baseServiceUrl}/getPanelDashboard`;
    return ServiceApi.get(url);
  }
};

export default ApiHome;